(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uwaga-global-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){var opener=event.target.closest('[data-ugh-open]');var closer=event.target.closest('[data-ugh-close]');if(!opener&&!closer)return;var header=document.querySelector('[data-ugh]');if(!header)return;var drawer=header.querySelector('[data-ugh-drawer]');var shade=header.querySelector('.ugh__shade');var isOpen=Boolean(opener);drawer.classList.toggle('is-open',isOpen);shade.classList.toggle('is-open',isOpen);drawer.setAttribute('aria-hidden',String(!isOpen));header.querySelector('[data-ugh-open]').setAttribute('aria-expanded',String(isOpen));document.body.classList.toggle('ugh-menu-open',isOpen)});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;var close=document.querySelector('[data-ugh-close]');if(close)close.click()});
function uwagaCookieCopy(){var dialog=document.querySelector('.shopify-pc__banner__dialog');var header=document.querySelector('[data-ugh]');if(!dialog||!header||dialog.dataset.uwagaCopy)return;var title=dialog.querySelector('h2');var copy=dialog.querySelector('p');if(title)title.textContent=header.dataset.cookieTitle;if(copy){copy.textContent=header.dataset.cookieCopy+' ';var link=document.createElement('a');link.href=header.dataset.cookiePrivacyUrl;link.textContent=header.dataset.cookiePrivacy;copy.appendChild(link)}var manage=dialog.querySelector('#shopify-pc__banner__btn-manage-prefs');var decline=dialog.querySelector('#shopify-pc__banner__btn-decline');var accept=dialog.querySelector('#shopify-pc__banner__btn-accept');if(manage)manage.textContent=header.dataset.cookieManage;if(decline)decline.textContent=header.dataset.cookieDecline;if(accept)accept.textContent=header.dataset.cookieAccept;dialog.dataset.uwagaCopy='true'}
new MutationObserver(uwagaCookieCopy).observe(document.documentElement,{childList:true,subtree:true});uwagaCookieCopy();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uwaga-journal-hero"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(section){
      if(!section||section.dataset.ujhReady)return;
      section.dataset.ujhReady='1';
      var rail=section.querySelector('[data-ujh-rail]');
      var paused=false;
      function step(){
        var slide=rail.querySelector('.ujh__slide');
        rail.scrollBy({left:slide?slide.getBoundingClientRect().width:rail.clientWidth*.88,behavior:'smooth'});
      }
      ['pointerenter','touchstart','focusin'].forEach(function(name){rail.addEventListener(name,function(){paused=true},{passive:true})});
      ['pointerleave','touchend','focusout'].forEach(function(name){rail.addEventListener(name,function(){paused=false},{passive:true})});
      setInterval(function(){
        if(paused||document.hidden)return;
        if(rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4)rail.scrollTo({left:0,behavior:'smooth'});
        else step();
      },4200);
    }
    document.querySelectorAll('.ujh').forEach(init);
    document.addEventListener('shopify:section:load',function(event){init(event.target.querySelector('.ujh'))});
  })();
  } catch(e) { console.error(e); }
})();

})();
